import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import NavbarComponent from "./navbar";
import Footer from "./footer";

const Pricing = () => {

    useEffect(() => {

        const scriptId = "zoho-pricing-widget-script";

        if (!document.getElementById(scriptId)) {

            const script = document.createElement("script");

            script.id = scriptId;
            script.src =
                "https://static.zohocdn.com/zfwidgets/v1/hpwidgets/assets/js/zf-widget.js";

            script.async = true;

            document.body.appendChild(script);
        }

    }, []);

    return (
        <>
            {/* INLINE CSS */}
            <style>{`

body {
    background: #f5f1fc;
}
    .pricing-table-header .filters {
    -ms-flex-pack: justify;
    justify-content: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}


li.plan-item {
    /* gap: 24px; */
    padding: 6px !Important;
}
    
.pricing_container {
        max-width: 1007px;
        margin:auto;
    }

            `}</style>


            {/* Pricing Page */}

            <div className="pricingnavbar1">
                <NavbarComponent />
            </div>

            <div className="container text-center">

                <h6 className="toodhupricing">
                    PRICING
                </h6>

                <h2 className="perfectplan">
                    Unlock Your Perfect Solution
                </h2>

                <p className="toodhulorem">
                    Choose the perfect solution to streamline your business
                    with Toodhu. Enjoy powerful collaboration, seamless
                    integration, and real-time insights for enhanced
                    productivity.
                </p>

            </div>


            {/* Zoho Pricing Widget */}

            <div className="pricing_container text-center">
                <div
                    id="zf-widget-root-id-5jy61kl5s"
                    className="pricing-zoho-widget"
                    data-pricing-table="true"
                    data-digest="2-19335349e07da5a988f6d3d582d85b9a8f0c157487261d0a6de553388063fdef32ecff7dba5acec3b737c2b253195bdf6f76d3dc1746c6c2008d0dd7900d4018"
                    data-product_url="https://billing.zoho.in"
                >
                </div>

            </div>

        </>
    );
};

export default Pricing;